module.exports = __webpack_public_path__ + "media/Chapter1AudioLoop.ee4326e5.mp3";